import { Chip } from '@mui/material';

const STATUS_CONFIG: Record<string, { label: string; color: 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'info' }> = {
  proposed: { label: 'Proposé', color: 'info' },
  confirmed: { label: 'Confirmé', color: 'primary' },
  postponed: { label: "Décalé, en attente d'une nouvelle date", color: 'secondary' },
  completed: { label: 'Complété', color: 'success' },
  no_show_pending: { label: 'No-show en attente', color: 'warning' },
  no_show: { label: 'No-show', color: 'error' },
  cancelled_by_agent: { label: 'Annulé (agence)', color: 'default' },
  cancelled: { label: 'Annulé (particulier)', color: 'default' },
};

interface RdvStatusBadgeProps {
  status: string;
}

const RdvStatusBadge = ({ status }: RdvStatusBadgeProps) => {
  const config = STATUS_CONFIG[status] ?? { label: status, color: 'default' as const };
  return <Chip label={config.label} color={config.color} size="small" />;
};

export default RdvStatusBadge;
